import { Capacitor } from "@capacitor/core";

export type Surface = "desktop_web" | "mobile_web" | "native";

/**
 * Resolve the current device surface — the canonical 3-way split
 * (desktop_web / mobile_web / native) that backs experiment analysis.
 *
 * Distinct from `platform` (web/ios/android) because Mollie payments come in
 * as platform=web for both desktop and mobile browsers, collapsing two
 * surfaces we want to analyze separately. Mirrors the same UA + Capacitor
 * detection used by PostHogProvider when registering the `surface` super-prop,
 * so backend-fired events (subscription_completed) match frontend-fired ones.
 *
 * Returns null on the server (no `navigator`).
 */
export function computeSurface(): Surface | null {
  if (typeof window === "undefined") return null;
  if (Capacitor.isNativePlatform()) return "native";
  const uaMobile =
    typeof navigator !== "undefined" &&
    /Mobi|Android|iPhone|iPad|iPod/i.test(navigator.userAgent);
  return uaMobile ? "mobile_web" : "desktop_web";
}
